import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Toast } from '../ui/Toast';
import { useMotionPreference } from '../../hooks/useMotionPreference';
import { useSpecSettings } from '../../contexts/SpecSettingsContext';
import { playSound } from '../../utils/sound';
import type { SoundId } from '../../types/anna';
const samples: Record<SoundId, {
  title: string;
  detail: string;
  button: string;
}> = {
  klaar: {
    title: 'Klaar',
    detail: 'PR #142 klaar voor review',
    button: 'Klaar'
  },
  meldt: {
    title: 'Meeting met Lisa om 14:00',
    detail: 'Vertrek om 13:30, het gaat regenen',
    button: 'Meldt'
  },
  geweigerd: {
    title: 'Geweigerd',
    detail: 'Onbekende stem vroeg om de voordeur te openen',
    button: 'Geweigerd'
  }
};
export function ToastDemo() {
  const [active, setActive] = useState<{
    id: number;
    tone: SoundId;
  } | null>(null);
  const reduce = useMotionPreference();
  const {
    soundOn
  } = useSpecSettings();
  useEffect(() => {
    if (!active) return;
    const t = window.setTimeout(() => setActive(null), 4000);
    return () => window.clearTimeout(t);
  }, [active]);
  const show = (tone: SoundId) => {
    setActive({
      id: Date.now(),
      tone
    });
    if (soundOn) playSound(tone);
  };
  return <>
      <Toast tone="klaar" title={samples.klaar.title} detail={samples.klaar.detail} data-id="element-1083" data-mp="1oq5iah2ocpye" />
      <div className="mt-4 flex flex-wrap gap-2" data-id="element-1084" data-mp="1snuw5wfz0esp">
        {(Object.keys(samples) as SoundId[]).map(tone => <button key={tone} type="button" onClick={() => show(tone)} className="h-9 whitespace-nowrap rounded-full border border-white/10 px-3.5 text-[13px] font-medium text-ink-soft transition-colors duration-150 hover:border-white/20 hover:text-ink" data-id="element-1085" data-mp="1ew6n6210q6fy">
            Toon “{samples[tone].button}”
          </button>)}
      </div>
      <div className="pointer-events-none fixed inset-x-0 bottom-6 z-50 flex justify-center px-4" data-id="element-1086" data-mp="w1i3938iqwta">
        <AnimatePresence data-id="element-1087" data-mp="110kwzrj1tgly">
          {active && <motion.div key={active.id} className="pointer-events-auto w-full max-w-[380px]" initial={reduce ? {
          opacity: 0
        } : {
          opacity: 0,
          y: 12,
          scale: 0.98
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={reduce ? {
          opacity: 0
        } : {
          opacity: 0,
          y: 8
        }} transition={{
          duration: 0.2,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-1088" data-mp="32nxp1cq2mgiy">
              <Toast tone={active.tone} title={samples[active.tone].title} detail={samples[active.tone].detail} onClose={() => setActive(null)} data-id="element-1089" data-mp="3ll8lyqo8cxv8" />
            </motion.div>}
        </AnimatePresence>
      </div>
    </>;
}